export const FILE_RENAME_SUGGESTION_TARGET_SELECTOR =
  '[data-onboarding-target="file-rename-suggestion"]';

export const FLY_ANIMATION_MS = 450;
